<div>
    <iframe [src]="safeUrl" frameborder="0" style="width:100%; height: 700px;" ></iframe>
</div>
